<template>
    <div>
        <section v-if="_.get(product,'series.descriptions.series-cutsheet.0.long',false)">
            <h2 class="text-xl at1024:text-3xl font-bold mb-5" v-html="_.get(product, 'series.name', '')"></h2>
            <div class="series-cutsheet-long" v-html="_.get(product,'series.descriptions.series-cutsheet.0.long')"></div>
        </section>
        <template v-else-if="hasSeriesDescription">
            <h2 class="text-xl at1024:text-3xl font-bold mb-5" v-if="_.get(product, 'series.name', false)" v-html="_.get(product, 'series.name', '')"></h2>
            <p class="text-lg at1024:text-2xl series-description-short mb-6" v-if="_.get(product, 'series.descriptions.series-description.0.short', false)">
                {{ _.get(product, "series.descriptions.series-description.0.short", "") }}
            </p>
            <div class="series-description-long" v-if="_.get(product,'series.descriptions.series-description.0.long',false)" v-html="_.get(product,'series.descriptions.series-description.0.long','')"></div>
            <div class="series-specification-long" v-if="_.get(product,'series.descriptions.series-specification.0.long',false)" v-html="_.get(product,'series.descriptions.series-specification.0.long','')"></div>
        </template>
        <template v-else>
            <h2 class="text-xl at1024:text-3xl font-bold mb-5" v-html="_.get(product, 'series.name', '')"></h2>
            <p class="text-lg at1024:text-2xl series-description-short mb-6">
                {{ _.get(product, "descriptions.product-description.0.short", "") }}
            </p>
            <div class="series-description-long" v-html="_.get(product,'descriptions.product-description.0.long','') "></div>
        </template>
    </div>
</template>

<script setup>
import _ from "lodash";
import {computed} from "vue";
const props = defineProps(["product"]);

const hasSeriesDescription = computed(() => {
    let product = props.product;
    return _.get(product, "series.descriptions.series-description.0.long", false) ||
        _.get(product, "series.descriptions.series-description.0.short", false) ||
        _.get(product,'series.descriptions.series-specification.0.long', false);
});
</script>

<style scoped>
.series-description-short :deep(h3),
.series-description-long :deep(h3),
.series-specification-long :deep(h3),
.series-cutsheet-long :deep(h3) {
    letter-spacing: -0.01em;
    line-height: 1.1em;
    font-size: 1.6em;
    font-weight: 700;
    margin-bottom: 0.75em;
}

.series-description-short :deep(h4),
.series-description-long :deep(h4),
.series-specification-long :deep(h4),
.series-cutsheet-long :deep(h4) {
    line-height: 1.2em;
    font-size: 1.4em;
    margin-bottom: 0.75em;
}

.series-description-short :deep(p),
.series-description-long :deep(p),
.series-specification-long :deep(p),
.series-cutsheet-long :deep(p) {
    line-height: 1.4;
    margin-bottom: 1.5em;
    @apply type-secondary;
}

.series-description-long :deep(ul),
.series-description-long :deep(ol),
.series-specification-long :deep(ul),
.series-specification-long :deep(ol),
.series-cutsheet-long :deep(ul),
.series-cutsheet-long :deep(ol) {
    list-style-type: disc;
    margin: 0 0 1.6em 25px;
    padding: 0;
}

.series-description-long :deep(img),
.series-specification-long :deep(img),
.series-cutsheet-long :deep(img) {
    display: inline;
    margin-bottom: 1em;
}

.series-description-long :deep(hr),
.series-specification-long :deep(hr),
.series-cutsheet-long :deep(hr) {
    border-color: #eaeaea;
    margin-bottom: 1.5em;
}

.dark .series-description-long :deep(hr),
.dark .series-specification-long :deep(hr),
.dark .series-cutsheet-long :deep(hr) {
    border-color: #1f1f1f;
}

.series-description-long :deep(table),
.series-specification-long :deep(table),
.series-cutsheet-long :deep(table) {
    @apply mb-6;
}

.series-description-long :deep(tr:nth-child(even)),
.series-specification-long :deep(tr:nth-child(even)),
.series-cutsheet-long :deep(tr:nth-child(even)) {
    background-color: #f5f5f5;
}

.dark .series-description-long :deep(tr:nth-child(even)),
.dark .series-specification-long :deep(tr:nth-child(even)),
.dark .series-cutsheet-long :deep(tr:nth-child(even)) {
    background-color: #272727;
}

.series-description-long :deep(td),
.series-specification-long :deep(td),
.series-cutsheet-long :deep(td) {
    font-size: 0.9em;
    padding: 10px 15px;
}

@media screen and (min-width: 1024px) {
    .series-description-long :deep(td),
    .series-specification-long :deep(td),
    .series-cutsheet-long :deep(td) {
        font-size: 18px;
        padding: 12px 20px;
    }
}

.series-description-long :deep(td:first-child),
.series-specification-long :deep(td:first-child),
.series-cutsheet-long :deep(td:first-child) {
    font-weight: 600;
}

.series-description-long :deep(td ul),
.series-specification-long :deep(td ul),
.series-cutsheet-long :deep(td ul) {
    margin-bottom: 0;
}
</style>
